import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useRootStore } from 'stores/RootStore'
import { useCreditUsage } from './useCreditUsage'

export const useShowCreditsPaywall = () => {
  const {
    tierUsageStore: { autopilotAddOns, currentSubscription },
  } = useRootStore()
  const { canAutoReload, creditsRemaining } = useCreditUsage()
  const autopilotContentCreditsAddon = autopilotAddOns.find(
    (addon) => addon.key === PaymentPlanKey.BlazeAutopilotContentCredits,
  )
  const autopilotContentCreditsPrice = autopilotContentCreditsAddon?.prices?.[0]
  const isTrackingCredits =
    currentSubscription?.plan &&
    [PaymentPlanKey.BlazeAutopilotStarter, PaymentPlanKey.BlazeAutopilotGrowth].includes(currentSubscription.plan)
  const showCreditsPaywall = isTrackingCredits && !!(creditsRemaining === 0) && !canAutoReload

  return { showCreditsPaywall, price: autopilotContentCreditsPrice, isTrackingCredits }
}
